var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"Monitor","name":"monitor"}},[_c('supervisor-monitor')],1),_c('el-tab-pane',{attrs:{"label":"Settings","name":"settings"}},[_c('SupervisorSettings')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }